import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Button, Input, ModalDelete } from "expano-components";
import { Main } from "layouts";
import {
  getBrandLabel,
  updateBrandLabel,
  deleteBrandLabel,
} from "actions/brand_labels";

import { ReactComponent as StickerIcon } from "icons/sticker.svg";
import { ReactComponent as InfoIcon } from "icons/info.svg";
import ImageField from "../components/ImageField";

const InputField = (props) => <Input {...props} />;

const BrandLabelEdit = ({
  history,
  match: { params },
  brand_label,
  getBrandLabel,
  updateBrandLabel,
  handleSubmit,
  pristine,
  invalid,
  submitting,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { data } = brand_label;

  useEffect(() => {
    getBrandLabel(params.id);
  }, [params.id]);

  const onSubmit = (values) => {
    const payload = { name: values.name };
    if (values.image_data) {
      payload.image_data = values.image_data;
    }
    return updateBrandLabel(data.id, payload);
  };

  const handleDelete = () =>
    deleteBrandLabel(data.id).then(() => history.push("/brand-labels"));

  return (
    <Main
      is_loading={["invalid", "loading", "failure"].includes(
        brand_label.status,
      )}
      page={{
        name: data?.name,
        icon: <StickerIcon />,
        breadcrumbs: [
          { name: "Etykiety markowe", path: "/brand-labels" },
          { name: data?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń etykietę"
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {showDeleteModal && (
        <ModalDelete
          handleDelete={handleDelete}
          handleClose={() => setShowDeleteModal(false)}
          name={`etykietę markową ${data?.name}`}
        />
      )}
      <div className="dashboard-wrapper-flex m-t-10">
        <div className="column-half">
          <form
            noValidate
            onSubmit={handleSubmit(onSubmit)}
            className="dashboard"
          >
            <header className="dashboard__header">
              <div className="icon__container">
                <InfoIcon />
              </div>
              <h2 className="dashboard__title heading">Podstawowe dane</h2>
            </header>
            <div className="dashboard__form p-t-20">
              <Field name="name" label="Nazwa" component={InputField} />
              <Field
                name="image_data"
                label="Podgląd etykiety"
                component={ImageField}
                currentUrl={data?.image_url}
              />
            </div>
            <div className="dashboard__form__footer">
              <Button
                disabled={invalid || pristine || submitting}
                type="save"
                text="Zapisz"
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </form>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane";
  }
  return errors;
};

export default connect(
  ({ brand_label }) => ({
    brand_label,
    initialValues: {
      name: brand_label?.data?.name || "",
      image_data: "",
    },
  }),
  (dispatch) => ({
    getBrandLabel: (id) => dispatch(getBrandLabel(id)),
    updateBrandLabel: (id, values) => dispatch(updateBrandLabel(id, values)),
  }),
)(
  reduxForm({
    form: "edit-brand-label",
    validate,
    enableReinitialize: true,
  })(BrandLabelEdit),
);
